<div class="container-fluid admin-form-page">
  <div class="row section1">
    <div class="col-12 col-md-7 col-lg-7 col-xl-7">
      <div class="home-details">
        <h5 class="home-title">Create New NFT Collection</h5>
        <p class="home-subtitle">Add Collection details to create listing</p>
      </div>
    </div>
    <div class="col-12 col-md-7 col-lg-5 col-xl-5">
      <div class="dashboard-btn dashboard-manage admin-page-actions">
        <div><a routerLink="/nfts-collection"><button type="button" class="btn btn-primary btn-dashboard">Back</button></a></div>
      </div>
    </div>
  </div>
  <div class="section1">
    @if (isCollectionCreated) {
      <div class="alert alert-success alert-dismissible fade show" style="margin:10px 0"
        role="alert"> New Collection {{collection.title}} Created
      </div>
    }
    @if (isError) {
      <div class="alert alert-danger alert-dismissible fade show" style="margin:10px 0;cursor: pointer"
        role="alert"><span>{{errMessage}}</span>
      </div>
    }
    <div class="applicants-details details1 admin-form-card">
      <form class="admin-form" enctype="multipart/form-data" ngNativeValidate (ngSubmit)="createCollection()">
        <div class="row">
          <div class="col-12 job-form">
            <div class="row align-items-center">
              <div class="col-2 ">
                <div class="user-form">
                  <div class="form-group d-flex flex-column">
                    <label class="text-nowrap">Choose Collection Image*</label>
                    @if (collection.thumbnail) {
                      <img class="position-relative " style="object-fit: cover" width="100" height="100"
                        src="{{collection.thumbnail}}" alt="">
                    }
                    @if (!collection.thumbnail) {
                      <img class="position-relative " style="object-fit: cover" width="100"
                        height="100"
                        src="assets/images/placeholder.png" alt="">
                      }
                      @if (!collection.thumbnail && !uploading) {
                        <i (click)="handleClickUpload()"
                        class="las font-size-16 la-plus-circle img-icon"></i>
                      }
                      @if (collection.thumbnail && !uploading) {
                        <i (click)="handleClickUpload()"
                        class="las font-size-16 la-pencil-alt img-icon"></i>
                      }
                      @if (uploading) {
                        <div class="img-icon-loader">
                          <img src="assets/images/loading.gif" width="40" alt="">
                        </div>
                      }
                    </div>
                    <input id="dp" name="file-upload-field" type="file"
                      accept=".png, .jpg, .jpeg, .webp"
                      class="form-control d-none"
                      (change)="fileChangeEvent($event, imageCropperModal)" required>
                  </div>
                </div>
                <div class="col-4">
                  <div class="user-form">
                    <div class="form-group">
                      <label for="c-title">Collection Title*</label>
                      <input type="text" class="form-control" required id="c-title" name="c-title "
                        [(ngModel)]="collection.title" placeholder="Enter Title">
                    </div>
                  </div>
                </div>

                <div class="col-3">
                  <div class="user-form">
                    <div class="form-group">
                      <label for="e-category">Entity Category*</label>
                      <select id="e-category" class="form-control" #category name="e-category"
                        [(ngModel)]="collection.category" (ngModelChange)="categoryChange()" required>
                        <option selected disabled>Select Category</option>
                        @for (c of categories; track c) {
                          <option [value]="c.id">{{c.categoryName}}</option>
                        }
                      </select>
                    </div>
                  </div>
                </div>

                <div class="col-3">
                  <div class="user-form">
                    <div class="form-group">
                      <label for="entity">Entity*</label>
                      <select [disabled]="entities.length == 0" id="entity" class="form-control" #category name="entity"
                        [(ngModel)]="collection.entity" required>
                        <option selected disabled>Select Category</option>
                        @for (e of entities; track e) {
                          <option [value]="e.id">{{e.entityName}}</option>
                        }
                      </select>
                    </div>
                  </div>
                </div>

                <div class="col-12">
                  <div class="user-form">
                    <div class="form-group">
                      <label for="c-description">Description*</label>
                      <textarea type="text" class="form-control"
                        rows="4"
                        required id="c-description" name="entity-label"
                      [(ngModel)]="collection.description" placeholder="Enter Description"></textarea>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-12">
            @if (!isCollectionCreated) {
              <div class="row align-items-center justify-content-end mt-2">
                <button type="submit" class="btn btn-primary btn-dashboard" >Save NFT Collection</button>
              </div>
            }
          </div>

        </form>
      </div>
    </div>
  </div>


  <ng-template #imageCropperModal>
    <div class="modal-header">
      <h5 class="modal-title">Add NFT image</h5>
      <button type="button" class="close " data-dismiss="modal" aria-label="Close" (click)="modalRef.hide()">
        <span aria-hidden="true" class="">&times;</span>
      </button>
    </div>
    <div class="modal-body">
      <image-cropper
        (imageCropped)="imageCropped($event)"
        (loadImageFailed)="loadImageFailed()"
        [aspectRatio]=aspectRatio
        [imageChangedEvent]="imageChangedEvent"
        [maintainAspectRatio]="true"
        format="png">
      </image-cropper>
    </div>
    <div class="modal-footer justify-content-end">
      <button type="button" class="btn btn-default mr-2" data-dismiss="modal" (click)="modalRef.hide()">Close</button>
      <button (click)="uploadImage(this.croppedFile); modalRef.hide()" class="btn btn-primary btn-dashboard" type="button">Crop
      </button>
    </div>
  </ng-template>
